import React, { useState, useEffect } from "react";
import {
  Box,
  Flex,
  Heading,
  Select,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Text,
  Spinner,
  Button,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import moment from "moment";
import axios from "axios";
import { useAuth } from "../auth/AuthProvider";
import { useNavigate } from "react-router-dom";
import { server } from "../util/connect";
import jsPDF from "jspdf";
import "jspdf-autotable";
import html2canvas from "html2canvas";
import "../css/CustomTable.css";
import PatientRecordModal from "./modals/PatientRecordModal";
import { callAddFont } from "../js/THSarabunNew-normal";
import { th } from "date-fns/locale/th";
import { format } from "date-fns";

const PatientHist = ({ histType }) => {
  const navigate = useNavigate();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [records, setRecords] = useState([]);
  const [doctors, setDoctors] = useState([]);
  const { user } = useAuth();
  const currentYear = new Date().getFullYear();
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const [selectedDoctorID, setSelectedDoctorID] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [selectedMonth, setSelectedMonth] = useState(moment().format("M"));
  const [isDownloading, setDownloading] = useState(false);
  const [selectedRowIndex, setSelectedRowIndex] = useState();
  const [timeIncluded, setTimeIncluded] = useState("time_not_included")
  const [yearlySummary, setYearlySummary] = useState([]);
  const [doctorMonthlyRows, setDoctorMonthlyRows] = useState([]);
  const [doctorMonthlyGrandTotal, setDoctorMonthlyGrandTotal] = useState(0);
  const [isDoctorMonthlyLoading, setIsDoctorMonthlyLoading] = useState(false);
  const toast = useToast();

  const years = Array.from({ length: 11 }, (_, index) => currentYear - index);

  useEffect(() => {
    if (user && user.department_id && doctors.length == 0) {
      loadDoctors(user.department_id);
    }
  }, [user]);

  useEffect(() => {
    if (selectedMonth && selectedYear && histType == "monthly") {
      const timerId = setTimeout(() => {
        if (user) {
          renderRecord();
        } else {
          navigate("/login");
        }
      }, 300);

      return () => clearTimeout(timerId);
    } else if (selectedYear && histType == "yearly") {
      const timerId = setTimeout(() => {
        if (user) {
          renderRecord();
        } else {
          navigate("/login");
        }
      }, 300);

      return () => clearTimeout(timerId);
    }
  }, [user, selectedMonth, selectedYear]);

  useEffect(() => {
    renderRecord();
  }, [selectedDoctorID]);

  useEffect(() => {
    if (!user || !user.department_id) return;
    console.log('call ---')

    if (histType === "yearly") {
      loadYearlySummary(user.department_id, selectedYear);
    } else {
      setYearlySummary([]);
    }
  }, [user, selectedYear, selectedDoctorID, histType]);

  const renderRecord = () => {
    const y = selectedYear;
    var m = "";

    if (histType == "monthly") {
      m = selectedMonth.length <= 1 ? `0${selectedMonth}` : selectedMonth;
    }

    if (user && user.department_id) {
      loadHistory(user.department_id, y, m);
    }
  };

  const handleYearChange = (event) => {
    setSelectedYear(parseInt(event.target.value, 10));
  };

  const handleMonthChange = (event) => {
    setSelectedMonth(event.target.value);
  };

  const handleSelectedDoctorChange = (event) => {
    setSelectedDoctorID(event.target.value);
  };

  const getYearlyTotal = (field) => {
    return yearlySummary.reduce((sum, row) => {
      return sum + (row[field] || 0);
    }, 0);
  };

  const getDoctorNameFromID = () => {
    var name = "";
    doctors.forEach((d) => {
      if (`${d.id}` == `${selectedDoctorID}`) {
        name = d.first_name;
      }
    });
    return name;
  };

  const checkNull = (val) => {
    return val == undefined || val == "" || val == 0 ? "" : val;
  };

  const loadHistory = (departmentId, year, month) => {
    setIsLoading(true);
    //getDoctorNameFromID(selectedDoctorID)
    axios
      .post(`${server}/daily_record/record_hist`, {
        withCredentials: true,
        department_id: departmentId,
        doctor_id: selectedDoctorID,
        doctor_name: getDoctorNameFromID(),
        year,
        month,
      })
      .then((response) => {
        //console.log(`response: ${JSON.stringify(response)}`);
        setIsLoading(false);
        setRecords(response.data.records);
      })
      .catch((error) => {
        setIsLoading(false);
        console.log(error);
      });
  };

  const loadDoctors = (departmentId) => {
    setIsLoading(true);
    axios
      .post(`${server}/daily_record/list_doctors`, {
        department_id: departmentId,
      })
      .then((response) => {
        setDoctors(response.data.doctors);
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        console.log(error);
      });
  };

  const sumCases = (case1, case2) => {
    const num1 = case1 || 0;
    const num2 = case2 || 0;
    return num1 + num2;
  };

  const calculateTotalSum = (columnName) => {
    columnName = !selectedDoctorID ? `sum_${columnName}` : columnName;

    return records.reduce((sum, record) => {
      return sum + (record[columnName] || 0);
    }, 0);
  };

  const loadYearlySummary = async (departmentId, year) => {
    // ใช้เฉพาะตอนเลือก "ยอดรายปี"
    if (histType !== "yearly") {
      setYearlySummary([]);
      return;
    }

    try {
      const doctorName = getDoctorNameFromID();
      const months = Array.from({ length: 12 }, (_, i) => i + 1);

      const responses = await Promise.all(
        months.map((m) => {
          const mm = m.toString().padStart(2, "0");
          return axios
            .post(`${server}/daily_record/record_hist`, {
              withCredentials: true,
              department_id: departmentId,
              doctor_id: selectedDoctorID,
              doctor_name: doctorName,
              year,
              month: mm,
            })
            .then((res) => ({ month: m, records: res.data.records || [] }));
        })
      );

      const summaryRows = responses.map(({ month, records }) => {
        // เลือกใช้ field ชนิดเดิม: ถ้าไม่เลือกหมอ → sum_xxx, ถ้าเลือกหมอ → xxx
        const sumField = (field) => {
          const key = !selectedDoctorID ? `sum_${field}` : field;
          return records.reduce(
            (sum, r) => sum + (r[key] || 0),
            0
          );
        };

        const oldO = sumField("old_o_case");
        const newO = sumField("new_o_case");
        const oldR = sumField("old_r_case");
        const newR = sumField("new_r_case");
        const admitO = sumField("admit_o_case");
        const admitR = sumField("admit_r_case");

        return {
          month,
          old_o_case: oldO,
          new_o_case: newO,
          o_total: oldO + newO,
          old_r_case: oldR,
          new_r_case: newR,
          r_total: oldR + newR,
          or_total: oldO + newO + oldR + newR,
          lab_num: sumField("lab_num"),
          xray_num: sumField("xray_num"),
          ekg_num: sumField("ekg_num"),
          abi_num: sumField("abi_num"),
          obesity_num: sumField("obesity_num"),
          treatment_num: sumField("treatment_num"),
          refer_num: sumField("refer_num"),
          ct_num: sumField("ct_num"),
          pft_num: sumField("pft_num"),
          blood_transfusion_num: sumField("blood_transfusion_num"),
          or_num: sumField("or_num"),
          chemo_num: sumField("chemo_num"),
          blood_letting_num: sumField("blood_letting_num"),
          lung_tap_num: sumField("lung_tap_num"),
          bone_marrow_tap_num: sumField("bone_marrow_tap_num"),
          vacc_rsv_num: sumField("vacc_rsv_num"),
          vacc_flu_num: sumField("vacc_flu_num"),
          vacc_ipd_num: sumField("vacc_ipd_num"),
          vacc_dengue_num: sumField("vacc_dengue_num"),
          vacc_zoster_num: sumField("vacc_zoster_num"),
          admit_o_case: admitO,
          admit_r_case: admitR,
          admit_total: admitO + admitR,
          check_up: sumField("check_up"),
        };
      });

      setYearlySummary(summaryRows);
    } catch (err) {
      console.error("loadYearlySummary error", err);
    }
  };

  const monthStrs = [
    "มกราคม",
    "กุมภาพันธ์",
    "มีนาคม",
    "เมษายน",
    "พฤษภาคม",
    "มิถุนายน",
    "กรกฎาคม",
    "สิงหาคม",
    "กันยายน",
    "ตุลาคม",
    "พฤศจิกายน",
    "ธันวาคม",
  ];

  const monthShortStrs = [
    "ม.ค",
    "ก.พ",
    "มี.ค",
    "เม.ย",
    "พ.ค",
    "มิ.ย",
    "ก.ค",
    "ส.ค",
    "ก.ย",
    "ต.ค",
    "พ.ย",
    "ธ.ค",
  ];

  function convertMinutesToHours(minutes) {
    if (typeof minutes !== "number" || minutes < 0) {
      return { hours: 0, minutes: 0 };
    }

    const mins = parseInt(minutes);
    const hours = Math.floor(mins / 60);
    const remainingMinutes = mins % 60;

    return { hours, minutes: remainingMinutes };
  }

  const getOffType = (r) => {
    if (selectedDoctorID) {
      return r.is_skipted
        ? "(งด)"
        : r.has_additional_period
          ? "(ชด)"
          : r.start_time && r.end_time
            ? ""
            : r.start_diag_time && r.end_diag_time
              ? ""
              : r.is_non_doctor
                ? ""
                : "(หยุด)";
    }
    else {
      return ""
    }
  };

  const getTimeSpent = (r) => {
    var min = 0;
    if (selectedDoctorID) {
      if (r.minute_spent && r.additional_minute_spent) {
        min = r.minute_spent + r.additional_minute_spent
      }
      else if (r.minute_spent) {
        min = r.minute_spent
      }
      else {
        min = r.additional_minute_spent
      }
    }

    const time = convertMinutesToHours(
      checkNull(selectedDoctorID ? min : (r.sum_minute_spent + r.sum_additional_minute_spent))
    )

    const h = time.hours ? `${time.hours} h` : "";
    const m = time.minutes ? `${time.minutes} m` : "";

    return `${h} ${m}`
  }

  const formatAdditionalTime = (e) => {
    const start = e.additional_start_diag_time
      ? moment(e.additional_start_diag_time, "HH:mm:ss").format("HH:mm")
      : "";
    const end = e.additional_end_diag_time
      ? moment(e.additional_end_diag_time, "HH:mm:ss").format("HH:mm")
      : "";
    return (e.has_additional_period && e.additional_start_diag_time) ? `${start}-${end}` : '';
  };

  const formatTime = (e) => {
    const start = e.start_diag_time
      ? moment(e.start_diag_time, "HH:mm:ss").format("HH:mm")
      : "";
    const end = e.end_diag_time
      ? moment(e.end_diag_time, "HH:mm:ss").format("HH:mm")
      : "";
    return (e.start_diag_time) ? `${start}-${end}` : '';
  };

  // 1) สร้าง helper ใน component ของคุณ
  const buildPdfDoc = () => {
    // 1) Prepare date/title
    const y = selectedYear;
    const m = histType === "monthly"
      ? selectedMonth.padStart(2, "0")
      : "";
    const dd = `${y}-${m}-01`;
    const thMonth = histType === "monthly"
      ? format(moment(dd, "YYYY-MM-DD").toDate(), "MMMM", { locale: th })
      : "";
    const title = histType === "monthly"
      ? `${thMonth} ${y}`
      : `${y}`;

    // 2) Define columns
    let columns = [
      selectedDoctorID ? "วันที่" : "แพทย์",
      "O เก่า", "O ใหม่", "O รวม",
      "R เก่า", "R ใหม่", "R รวม",
      "รวม O+R", "Lab", "X-Ray", "EKG",
      "ABI", "Obesity",
      "Treat.", "Refer",
      "CT", "PFT", "ให้เลือด", "OR",
      "Chemo", "B. letting", "จ.ปอด", "จ.ไขกระดูก", "V. RSV",
      "V. Flu", "V. IPD",
      "V. Dengue", "V. Zoster", "O Adm.", "R Adm.", "Adm. รวม",
      "Check up"
    ];
    if (!selectedDoctorID && timeIncluded === "time_included") {
      columns.push("ช. ทำงาน");
    } else if (selectedDoctorID && timeIncluded === "time_included") {
      columns.push("ช. ทำงาน", "เวลาออกชด", "เวลาตรวจจริง");
    } else if (selectedDoctorID && timeIncluded !== "time_included") {
      columns.push("เวลาออกชด");
    }

    // 3) Build rows
    const rows = records.map(r => {
      const base = [
        selectedDoctorID
          ? getThaiDayAbbreviation(r.day) + " " + getOffType(r)
          : r.first_name + " " + getOffType(r),
        checkNull(selectedDoctorID ? r.old_o_case : r.sum_old_o_case),
        checkNull(selectedDoctorID ? r.new_o_case : r.sum_new_o_case),
        checkNull(sumCases(
          selectedDoctorID ? r.old_o_case : r.sum_old_o_case,
          selectedDoctorID ? r.new_o_case : r.sum_new_o_case
        )),
        checkNull(selectedDoctorID ? r.old_r_case : r.sum_old_r_case),
        checkNull(selectedDoctorID ? r.new_r_case : r.sum_new_r_case),
        checkNull(sumCases(
          selectedDoctorID ? r.old_r_case : r.sum_old_r_case,
          selectedDoctorID ? r.new_r_case : r.sum_new_r_case
        )),
        checkNull(sumCases(
          sumCases(
            selectedDoctorID ? r.old_o_case : r.sum_old_o_case,
            selectedDoctorID ? r.new_o_case : r.sum_new_o_case
          ),
          sumCases(
            selectedDoctorID ? r.old_r_case : r.sum_old_r_case,
            selectedDoctorID ? r.new_r_case : r.sum_new_r_case
          )
        )),
        checkNull(selectedDoctorID ? r.lab_num : r.sum_lab_num),
        checkNull(selectedDoctorID ? r.xray_num : r.sum_xray_num),
        checkNull(selectedDoctorID ? r.ekg_num : r.sum_ekg_num),
        checkNull(selectedDoctorID ? r.abi_num : r.sum_abi_num),
        checkNull(selectedDoctorID ? r.obesity_num : r.sum_obesity_num),
        checkNull(selectedDoctorID ? r.treatment_num : r.sum_treatment_num),
        checkNull(selectedDoctorID ? r.refer_num : r.sum_refer_num),

        checkNull(selectedDoctorID ? r.ct_num : r.sum_ct_num),
        checkNull(selectedDoctorID ? r.pft_num : r.sum_pft_num),
        checkNull(selectedDoctorID ? r.blood_transfusion_num : r.sum_blood_transfusion_num),
        checkNull(selectedDoctorID ? r.or_num : r.sum_or_num),
        checkNull(selectedDoctorID ? r.chemo_num : r.sum_chemo_num),
        checkNull(selectedDoctorID ? r.blood_letting_num : r.sum_blood_letting_num),
        checkNull(selectedDoctorID ? r.lung_tap_num : r.sum_lung_tap_num),
        checkNull(selectedDoctorID ? r.bone_marrow_tap_num : r.sum_bone_marrow_tap_num),
        checkNull(selectedDoctorID ? r.vacc_rsv_num : r.sum_vacc_rsv_num),

        checkNull(selectedDoctorID ? r.vacc_flu_num : r.sum_vacc_flu_num),
        checkNull(selectedDoctorID ? r.vacc_ipd_num : r.sum_vacc_ipd_num),
        checkNull(selectedDoctorID ? r.vacc_dengue_num : r.sum_vacc_dengue_num),
        checkNull(selectedDoctorID ? r.vacc_zoster_num : r.sum_vacc_zoster_num),
        checkNull(selectedDoctorID ? r.admit_o_case : r.sum_admit_o_case),
        checkNull(selectedDoctorID ? r.admit_r_case : r.sum_admit_r_case),
        checkNull(sumCases(
          selectedDoctorID ? r.admit_o_case : r.sum_admit_o_case,
          selectedDoctorID ? r.admit_r_case : r.sum_admit_r_case
        )),
        checkNull(selectedDoctorID ? r.check_up : r.sum_check_up),
      ];
      if (!selectedDoctorID && timeIncluded === "time_included") {
        base.push(getTimeSpent(r));
      } else if (selectedDoctorID && timeIncluded === "time_included") {
        base.push(getTimeSpent(r), formatAdditionalTime(r), formatTime(r));
      } else if (selectedDoctorID && timeIncluded !== "time_included") {
        base.push(formatAdditionalTime(r));
      }
      return base;
    });

    // 4) Total row
    const totalRow = [
      "รวม",
      calculateTotalSum("old_o_case"),
      calculateTotalSum("new_o_case"),
      calculateTotalSum("old_o_case") + calculateTotalSum("new_o_case"),
      calculateTotalSum("old_r_case"),
      calculateTotalSum("new_r_case"),
      calculateTotalSum("old_r_case") + calculateTotalSum("new_r_case"),
      calculateTotalSum("old_o_case")
      + calculateTotalSum("new_o_case")
      + calculateTotalSum("old_r_case")
      + calculateTotalSum("new_r_case"),
      calculateTotalSum("lab_num"),
      calculateTotalSum("xray_num"),
      calculateTotalSum("ekg_num"),
      calculateTotalSum("abi_num"),
      calculateTotalSum("obesity_num"),
      calculateTotalSum("treatment_num"),
      calculateTotalSum("refer_num"),

      calculateTotalSum("ct_num"),
      calculateTotalSum("pft_num"),
      calculateTotalSum("blood_transfusion_num"),
      calculateTotalSum("or_num"),
      calculateTotalSum("chemo_num"),
      calculateTotalSum("blood_letting_num"),
      calculateTotalSum("lung_tap_num"),
      calculateTotalSum("bone_marrow_tap_num"),
      calculateTotalSum("vacc_rsv_num"),

      calculateTotalSum("vacc_flu_num"),
      calculateTotalSum("vacc_ipd_num"),
      calculateTotalSum("vacc_dengue_num"),
      calculateTotalSum("vacc_zoster_num"),
      calculateTotalSum("admit_o_case"),
      calculateTotalSum("admit_r_case"),
      calculateTotalSum("admit_o_case") + calculateTotalSum("admit_r_case"),
      calculateTotalSum("check_up"),
    ];
    if (!selectedDoctorID && timeIncluded === "time_included") {
      const t = convertMinutesToHours(
        calculateTotalSum("minute_spent") +
        calculateTotalSum("additional_minute_spent")
      );
      totalRow.push(`${t.hours} h, ${t.minutes} m`);
    } else if (selectedDoctorID && timeIncluded === "time_included") {
      const t = convertMinutesToHours(
        calculateTotalSum("minute_spent") +
        calculateTotalSum("additional_minute_spent")
      );
      totalRow.push(`${t.hours} h, ${t.minutes} m`, "", "");
    } else if (selectedDoctorID && timeIncluded !== "time_included") {
      totalRow.push("");
    }
    rows.push(totalRow);

    // 5) Embed Thai font
    jsPDF.API.events.push(["addFonts", callAddFont]);

    // 6) Create PDF
    const doc = new jsPDF("landscape");

    // 7) Header text
    const margin = 5;
    doc.setFont("THSarabunNew", "normal");
    doc.setFontSize(12);
    doc.text(
      `สรุปยอดราย${histType === "monthly" ? "เดือน" : "ปี"} ${selectedDoctorID ? "แพทย์" + getDoctorNameFromID() : user.department
      } (${title})`,
      margin,
      margin + 4
    );

    // 8) Draw table on one page
    const pageW = doc.internal.pageSize.getWidth();
    doc.autoTable({
      head: [columns],
      body: rows,
      startY: margin + 8,
      margin: { top: margin + 4, left: margin, right: margin, bottom: margin },
      tableWidth: pageW - margin * 2,
      styles: {
        font: "THSarabunNew",
        fontSize: 8,
        cellPadding: 1,
        cellWidth: "wrap",
        overflow: "ellipsize"
      },
      headStyles: { fillColor: [0, 84, 168], textColor: 255, cellPadding: 1 },
      theme: "grid",
      pageBreak: "avoid"
    });

    // 9) Filename
    const baseName = selectedDoctorID
      ? `${getDoctorNameFromID()} - สถิติราย${histType === "monthly" ? "เดือน" : "ปี"} ${title}`
      : `สถิติราย${histType === "monthly" ? "เดือน" : "ปี"} ${title}`;
    const filename = `${baseName} (ออกเอกสารเมื่อ ${moment().format(
      "DD-MM-YYYY_HH_mm_ss"
    )}).pdf`;

    return { doc, filename };
  };


  // 2) Export to PDF
  const exportToPDF = () => {
    setDownloading(true);
    const { doc, filename } = buildPdfDoc();
    doc.save(filename);
    setDownloading(false);
  };

  // 3) Share via Web Share API (fallback to download)
  const sharePdf = async () => {
    setDownloading(true);
    try {
      const { doc, filename } = buildPdfDoc();
      const blob = await doc.output("blob");
      const file = new File([blob], filename, { type: "application/pdf" });
      if (navigator.canShare?.({ files: [file] })) {
        await navigator.share({ files: [file], title: filename });
      } else {
        doc.save(filename);
      }
    } catch (err) {
      const isCancel = err.name === "AbortError" || err.name === "NotAllowedError";
      toast({
        title: isCancel ? "ยกเลิกการแชร์" : "แชร์ไฟล์ไม่สำเร็จ",
        description: err.message,
        status: isCancel ? "info" : "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setDownloading(false);
    }
  };

  const getThaiDayAbbreviation = (dateString) => {
    const thaiDays = ["อ.", "จ.", "อ.", "พ.", "พฤ.", "ศ.", "ส."];

    const date = new Date(dateString);
    const dayOfWeek = date.getDay();
    const day = moment(`${dateString}`, "YYYY-MM-DD").format("D");

    return `${day} ${thaiDays[dayOfWeek]}`;
  };

  const handleRowClick = (index) => {
    setSelectedRowIndex(index);
    onOpen();
  };

  const refreshTable = () => {
    renderRecord();
  };

  function generateRandomString(length) {
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let result = "";

    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * characters.length);
      result += characters.charAt(randomIndex);
    }

    return result;
  }

  const onModalClose = () => {
    setSelectedRowIndex(undefined)
    onClose()
  }

  const loadDoctorMonthlySummary = async (departmentId, year) => {
    // ใช้เฉพาะตอนดูยอดรายปี
    if (histType !== "yearly") {
      setDoctorMonthlyRows([]);
      setDoctorMonthlyGrandTotal(0);
      return;
    }

    try {
      setIsDoctorMonthlyLoading(true);

      const months = Array.from({ length: 12 }, (_, i) => i + 1);
      const doctorMap = {};

      const responses = await Promise.all(
        months.map((m) => {
          const mm = m.toString().padStart(2, "0");
          return axios
            .post(`${server}/daily_record/record_hist`, {
              withCredentials: true,
              department_id: departmentId,
              doctor_id: selectedDoctorID,         // ถ้าไม่เลือกหมอ = ทุกหมอ
              doctor_name: getDoctorNameFromID(),  // ถ้าเลือกหมอจะส่งชื่อไปด้วย
              year,
              month: mm,
            })
            .then((res) => ({
              monthIndex: m - 1,
              records: (res.data && res.data.records) || [],
            }))
            .catch(() => ({
              monthIndex: m - 1,
              records: [],
            }));
        })
      );

      responses.forEach(({ monthIndex, records }) => {
        records.forEach((r) => {
          const doctorName = r.first_name || getDoctorNameFromID() || "-";

          if (!doctorMap[doctorName]) {
            doctorMap[doctorName] = {
              name: doctorName,
              monthly: Array(12).fill(0),
            };
          }

          // O+R = O เก่า+ใหม่ + R เก่า+ใหม่
          const oOld = r.sum_old_o_case || 0;
          const oNew = r.sum_new_o_case || 0;
          const rOld = r.sum_old_r_case || 0;
          const rNew = r.sum_new_r_case || 0;
          const orTotal = oOld + oNew + rOld + rNew;

          doctorMap[doctorName].monthly[monthIndex] += orTotal;
        });
      });

      const rows = Object.values(doctorMap);

      const grandTotal = rows.reduce(
        (sum, row) => sum + row.monthly.reduce((s, v) => s + v, 0),
        0
      );

      rows.forEach((row) => {
        const total = row.monthly.reduce((s, v) => s + v, 0);
        row.total = total;
        row.percent = grandTotal ? (total * 100) / grandTotal : 0;
      });

      // ⭐ จัดเรียงใหม่ตามจำนวนเคส (O+R) และคงให้ “แพทย์อื่นๆ / ไม่พบแพทย์” อยู่ท้าย
      rows.sort((a, b) => {
        const special = ["แพทย์อื่นๆ", "ไม่พบแพทย์"];

        const aIsSpecial = special.includes(a.name);
        const bIsSpecial = special.includes(b.name);

        // ถ้า a เป็น special แต่ b ไม่เป็น → a ไปล่างสุด
        if (aIsSpecial && !bIsSpecial) return 1;

        // ถ้า b เป็น special แต่ a ไม่เป็น → b ไปล่างสุด
        if (!aIsSpecial && bIsSpecial) return -1;

        // ทั้งคู่เป็น special → เรียงตามชื่อ
        if (aIsSpecial && bIsSpecial)
          return a.name.localeCompare(b.name, "th");

        // ทั้งคู่เป็นคนปกติ → เรียงตามจำนวนเคสรวม (มาก → น้อย)
        return b.total - a.total;
      });

      setDoctorMonthlyRows(rows);
      setDoctorMonthlyGrandTotal(grandTotal);

    } catch (err) {
      console.error("loadDoctorMonthlySummary error:", err);
      setDoctorMonthlyRows([]);
      setDoctorMonthlyGrandTotal(0);
    } finally {
      setIsDoctorMonthlyLoading(false);
    }
  };

  useEffect(() => {
    if (!user || !user.department_id) return;

    if (histType === "yearly") {
      loadDoctorMonthlySummary(user.department_id, selectedYear);
    } else {
      setDoctorMonthlyRows([]);
      setDoctorMonthlyGrandTotal(0);
    }
  }, [user, histType, selectedYear, selectedDoctorID]);


  // === PDF: สรุปยอดแต่ละรายการในแต่ละเดือนของปี ===
  const buildYearlySummaryPdfDoc = () => {
    if (!yearlySummary.length) return null;

    jsPDF.API.events.push(["addFonts", callAddFont]);
    const doc = new jsPDF("landscape");

    const title = `สรุปยอดแต่ละรายการในแต่ละเดือนของปี ${selectedYear}${selectedDoctorID ? ` (${getDoctorNameFromID()})` : ` (${user.department})`
      }`;

    const columns = [
      "เดือน",
      "O เก่า",
      "O ใหม่",
      "O รวม",
      "R เก่า",
      "R ใหม่",
      "R รวม",
      "รวม O+R",
      "LAB",
      "X-RAY",
      "EKG",
      "ABI",
      "OBESITY",
      "TREAT.",
      "REFER",
      "CT",
      "PFT",
      "ให้เลือด",
      "OR",
      "CHEMO",
      "B. LETTING",
      "จ.ปอด",
      "จ.ไขกระดูก",
      "V. RSV",
      "V. FLU",
      "V. IPD",
      "V. DENGUE",
      "V. ZOSTER",
      "O ADM.",
      "R ADM.",
      "ADM. รวม",
      "CHECK UP",
    ];

    const rows = yearlySummary.map((row) => [
      monthStrs[row.month - 1],
      checkNull(row.old_o_case),
      checkNull(row.new_o_case),
      checkNull(row.o_total),
      checkNull(row.old_r_case),
      checkNull(row.new_r_case),
      checkNull(row.r_total),
      checkNull(row.or_total),
      checkNull(row.lab_num),
      checkNull(row.xray_num),
      checkNull(row.ekg_num),
      checkNull(row.abi_num),
      checkNull(row.obesity_num),
      checkNull(row.treatment_num),
      checkNull(row.refer_num),
      checkNull(row.ct_num),
      checkNull(row.pft_num),
      checkNull(row.blood_transfusion_num),
      checkNull(row.or_num),
      checkNull(row.chemo_num),
      checkNull(row.blood_letting_num),
      checkNull(row.lung_tap_num),
      checkNull(row.bone_marrow_tap_num),
      checkNull(row.vacc_rsv_num),
      checkNull(row.vacc_flu_num),
      checkNull(row.vacc_ipd_num),
      checkNull(row.vacc_dengue_num),
      checkNull(row.vacc_zoster_num),
      checkNull(row.admit_o_case),
      checkNull(row.admit_r_case),
      checkNull(row.admit_total),
      checkNull(row.check_up),
    ]);

    // แถวรวมทั้งปี
    rows.push([
      "รวม",
      checkNull(getYearlyTotal("old_o_case")),
      checkNull(getYearlyTotal("new_o_case")),
      checkNull(getYearlyTotal("o_total")),
      checkNull(getYearlyTotal("old_r_case")),
      checkNull(getYearlyTotal("new_r_case")),
      checkNull(getYearlyTotal("r_total")),
      checkNull(getYearlyTotal("or_total")),
      checkNull(getYearlyTotal("lab_num")),
      checkNull(getYearlyTotal("xray_num")),
      checkNull(getYearlyTotal("ekg_num")),
      checkNull(getYearlyTotal("abi_num")),
      checkNull(getYearlyTotal("obesity_num")),
      checkNull(getYearlyTotal("treatment_num")),
      checkNull(getYearlyTotal("refer_num")),
      checkNull(getYearlyTotal("ct_num")),
      checkNull(getYearlyTotal("pft_num")),
      checkNull(getYearlyTotal("blood_transfusion_num")),
      checkNull(getYearlyTotal("or_num")),
      checkNull(getYearlyTotal("chemo_num")),
      checkNull(getYearlyTotal("blood_letting_num")),
      checkNull(getYearlyTotal("lung_tap_num")),
      checkNull(getYearlyTotal("bone_marrow_tap_num")),
      checkNull(getYearlyTotal("vacc_rsv_num")),
      checkNull(getYearlyTotal("vacc_flu_num")),
      checkNull(getYearlyTotal("vacc_ipd_num")),
      checkNull(getYearlyTotal("vacc_dengue_num")),
      checkNull(getYearlyTotal("vacc_zoster_num")),
      checkNull(getYearlyTotal("admit_o_case")),
      checkNull(getYearlyTotal("admit_r_case")),
      checkNull(getYearlyTotal("admit_total")),
      checkNull(getYearlyTotal("check_up")),
    ]);

    const margin = 5;
    doc.setFont("THSarabunNew", "normal");
    doc.setFontSize(12);
    doc.text(title, margin, margin + 4);

    const pageW = doc.internal.pageSize.getWidth();
    doc.autoTable({
      head: [columns],
      body: rows,
      startY: margin + 8,
      margin: { top: margin + 4, left: margin, right: margin, bottom: margin },
      tableWidth: pageW - margin * 2,
      styles: {
        font: "THSarabunNew",
        fontSize: 8,
        cellPadding: 1,
        cellWidth: "wrap",
        overflow: "ellipsize",
      },
      headStyles: { fillColor: [0, 84, 168], textColor: 255 },
      theme: "grid",
    });

    const filename = `สรุปยอดแต่ละรายการ_${selectedYear}_${moment().format(
      "DD-MM-YYYY_HH_mm_ss"
    )}.pdf`;

    return { doc, filename };
  };

  const exportYearlySummaryPdf = () => {
    const built = buildYearlySummaryPdfDoc();
    if (!built) return;
    setDownloading(true);
    const { doc, filename } = built;
    doc.save(filename);
    setDownloading(false);
  };

  const shareYearlySummaryPdf = async () => {
    const built = buildYearlySummaryPdfDoc();
    if (!built) return;
    setDownloading(true);
    try {
      const { doc, filename } = built;
      const blob = await doc.output("blob");
      const file = new File([blob], filename, { type: "application/pdf" });
  
      if (navigator.canShare?.({ files: [file] })) {
        await navigator.share({ files: [file], title: filename });
      } else {
        doc.save(filename);
      }
    } catch (err) {
      const isCancel =
        err.name === "AbortError" || err.name === "NotAllowedError";
  
      if (isCancel) {
        // ผู้ใช้กดยกเลิก ไม่ต้องทำอะไร (จะไม่ขึ้น error แดงแล้ว)
        console.log("Share cancelled", err);
      } else {
        console.error("shareYearlySummaryPdf error", err);
        toast({
          title: "แชร์ไฟล์ไม่สำเร็จ",
          description: err.message,
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }
    } finally {
      setDownloading(false);
    }
  };  

  // === PDF: สถิติ O+R รายเดือน แยกตามแพทย์ ===
  const buildDoctorMonthlyPdfDoc = () => {
    if (!doctorMonthlyRows.length) return null;

    jsPDF.API.events.push(["addFonts", callAddFont]);
    const doc = new jsPDF("landscape");

    const title = `สถิติยอดคนไข้ (O+R) รายเดือน แยกตามแพทย์ ปี ${selectedYear}` + ` (${user.department})`;

    const columns = [
      "แพทย์",
      "จำนวน",
      "% จากยอดรวม",
      ...monthShortStrs,
    ];

    const rows = doctorMonthlyRows.map((row) => [
      row.name,
      row.total
        ? `${row.total.toLocaleString()}`
        : "",
      `${row.percent.toFixed(1)}%`,
      ...row.monthly.map((v) => checkNull(v)),
    ]);

    // แถวรวมด้านล่าง
    const monthTotals = monthShortStrs.map((_, idx) =>
      doctorMonthlyRows.reduce((sum, row) => sum + (row.monthly[idx] || 0), 0)
    );

    rows.push([
      "รวม",
      checkNull(doctorMonthlyGrandTotal),
      "",
      ...monthTotals.map((v) => checkNull(v)),
    ]);

    const margin = 5;
    doc.setFont("THSarabunNew", "normal");
    doc.setFontSize(12);
    doc.text(title, margin, margin + 4);

    const pageW = doc.internal.pageSize.getWidth();
    doc.autoTable({
      head: [columns],
      body: rows,
      startY: margin + 8,
      margin: { top: margin + 4, left: margin, right: margin, bottom: margin },
      tableWidth: pageW - margin * 2,
      styles: {
        font: "THSarabunNew",
        fontSize: 8,
        cellPadding: 1,
        cellWidth: "wrap",
        overflow: "ellipsize",
      },
      headStyles: { fillColor: [0, 84, 168], textColor: 255 },
      theme: "grid",
    });

    const filename = `สถิติยอดคนไข้รายเดือนตามแพทย์_${selectedYear}_${moment().format(
      "DD-MM-YYYY_HH_mm_ss"
    )}.pdf`;

    return { doc, filename };
  };

  const exportDoctorMonthlyPdf = () => {
    const built = buildDoctorMonthlyPdfDoc();
    if (!built) return;
    setDownloading(true);
    const { doc, filename } = built;
    doc.save(filename);
    setDownloading(false);
  };

  const shareDoctorMonthlyPdf = async () => {
    const built = buildDoctorMonthlyPdfDoc();
    if (!built) return;
    setDownloading(true);
    try {
      const { doc, filename } = built;
      const blob = await doc.output("blob");
      const file = new File([blob], filename, { type: "application/pdf" });
  
      if (navigator.canShare?.({ files: [file] })) {
        await navigator.share({ files: [file], title: filename });
      } else {
        doc.save(filename);
      }
    } catch (err) {
      const isCancel =
        err.name === "AbortError" || err.name === "NotAllowedError";
  
      if (isCancel) {
        console.log("Share cancelled", err);
      } else {
        console.error("shareDoctorMonthlyPdf error", err);
        toast({
          title: "แชร์ไฟล์ไม่สำเร็จ",
          description: err.message,
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }
    } finally {
      setDownloading(false);
    }
  };  

  return (
    <Box px={{ base: 0, md: 4 }} bgColor="blue.50" pb={10}>
      {selectedDoctorID &&
        records &&
        selectedRowIndex >= 0 &&
        records[selectedRowIndex] && (
          <PatientRecordModal
            refreshTable={refreshTable}
            curdate={records[selectedRowIndex].day}
            recordData={records[selectedRowIndex]}
            isOpen={isOpen}
            onClose={onModalClose}
          />
        )}

      <Flex direction={"column"} align={"center"}>
        <Text my={2} fontWeight={700} fontSize={18}>
          ยอดราย{histType == "monthly" ? "เดือน" : "ปี"}{" "}
          {user ? user.department : ""}
        </Text>

        <Flex my={2}>
          {selectedMonth && histType == "monthly" && (
            <Select
              size={"sm"}
              mr={1}
              w={"110px"}
              onChange={handleMonthChange}
              value={selectedMonth}
            >
              {monthStrs.map((month, index) => (
                <option key={index} value={index + 1}>
                  {month}
                </option>
              ))}
            </Select>
          )}

          {histType == "yearly" && <Text alignSelf={"center"} mr={1}>เลือกปี:</Text>}
          <Select
            size={"sm"}
            mr={1}
            w={"80px"}
            value={selectedYear}
            onChange={handleYearChange}
          >
            {years.map((year) => (
              <option key={year} value={year}>
                {year}
              </option>
            ))}
          </Select>

          {histType == "monthly" && (
            <Select
              size={"sm"}
              w={"135px"}
              value={selectedDoctorID}
              onChange={handleSelectedDoctorChange}
            >
              <option value="">แพทย์ทั้งหมด</option>
              {doctors &&
                doctors.map((d) => (
                  <option key={`doctor_${d.id}`} value={d.id}>
                    {`${d.first_name} ${d.last_name}`}
                  </option>
                ))}
            </Select>
          )}
        </Flex>
      </Flex>

      <Box display="flex" alignItems="center" justifyContent="center">
        <Box
          maxW={"1700px"}
          overflowX="auto"
          css={{
            "&::-webkit-scrollbar": {
              height: { base: "6px", md: "10px" }, // Set width of the scrollbar
            },
            "&::-webkit-scrollbar-thumb": {
              background: "#a0aec0", // Set color of the scrollbar thumb
            },
          }}
        >
          {!isLoading && records.length > 0 && (
            <Table id="pdf-table" size="xs" className="custom-table">
              <Thead>
                <Tr h={"40px"} key={`all_doctor_${generateRandomString(5)}`}>
                  <Th px={2} minW={"80px"}>{selectedDoctorID ? "วันที่" : "แพทย์"}</Th>
                  <Th px={2}>O เก่า</Th>
                  <Th px={2}>O ใหม่</Th>
                  <Th px={2}>O รวม</Th>
                  <Th px={2}>R เก่า</Th>
                  <Th px={2}>R ใหม่</Th>
                  <Th px={2}>R รวม</Th>
                  <Th px={2}>รวม O+R</Th>
                  <Th px={2}>Lab</Th>
                  <Th px={2}>X-Ray</Th>
                  <Th px={2}>EKG</Th>
                  <Th px={2}>ABI</Th>
                  <Th px={2}>Obesity</Th>
                  <Th px={2}>Treat.</Th>
                  <Th px={2}>Refer</Th>

                  <Th px={2}>CT</Th>
                  <Th px={2}>PFT</Th>
                  <Th px={2}>ให้เลือด</Th>
                  <Th px={2}>OR</Th>
                  <Th px={2}>Chemo</Th>
                  <Th px={2}>Blood letting</Th>
                  <Th px={2}>เจาะปอด</Th>
                  <Th px={2}>เจาะไขกระดูก</Th>
                  <Th px={2}>V. RSV</Th>

                  <Th px={2}>V. Flu</Th>
                  <Th px={2}>V. IPD</Th>
                  <Th px={2}>V. Dengue</Th>
                  <Th px={2}>V. Zoster</Th>
                  <Th px={2}>O Adm.</Th>
                  <Th px={2}>R Adm.</Th>
                  <Th px={2}>Adm. รวม</Th>
                  <Th px={2}>Check up</Th>
                  <Th px={2} minW={"80px"}>ชั่วโมงทำงาน</Th>
                  <Th px={2} minW={"80px"} display={!selectedDoctorID ? "none" : "table-cell"}>เวลาตรวจจริง</Th>
                  <Th px={2} minW={"80px"} display={!selectedDoctorID ? "none" : "table-cell"}>เวลาออกชด</Th>
                </Tr>
              </Thead>
              <Tbody>
                {!selectedDoctorID &&
                  records.length > 0 &&
                  records.map((r) => (
                    <Tr
                      key={`all_doctor_${generateRandomString(5)}`}
                      h={"45px"}
                    >
                      <Td>{r.first_name}</Td>
                      <Td>{checkNull(r.sum_old_o_case)}</Td>
                      <Td>{checkNull(r.sum_new_o_case)}</Td>
                      <Td>
                        {checkNull(
                          sumCases(r.sum_old_o_case, r.sum_new_o_case)
                        )}
                      </Td>
                      <Td>{checkNull(r.sum_old_r_case)}</Td>
                      <Td>{checkNull(r.sum_new_r_case)}</Td>
                      <Td>
                        {checkNull(
                          sumCases(r.sum_old_r_case, r.sum_new_r_case)
                        )}
                      </Td>
                      <Td>
                        {checkNull(
                          sumCases(
                            sumCases(r.sum_old_o_case, r.sum_new_o_case),
                            sumCases(r.sum_old_r_case, r.sum_new_r_case)
                          )
                        )}
                      </Td>
                      <Td>{checkNull(r.sum_lab_num)}</Td>
                      <Td>{checkNull(r.sum_xray_num)}</Td>
                      <Td>{checkNull(r.sum_ekg_num)}</Td>
                      <Td>{checkNull(r.sum_abi_num)}</Td>
                      <Td>{checkNull(r.sum_obesity_num)}</Td>
                      <Td>{checkNull(r.sum_treatment_num)}</Td>
                      <Td>{checkNull(r.sum_refer_num)}</Td>

                      <Td>{checkNull(r.sum_ct_num)}</Td>
                      <Td>{checkNull(r.sum_pft_num)}</Td>
                      <Td>{checkNull(r.sum_blood_transfusion_num)}</Td>
                      <Td>{checkNull(r.sum_or_num)}</Td>
                      <Td>{checkNull(r.sum_chemo_num)}</Td>
                      <Td>{checkNull(r.sum_blood_letting_num)}</Td>
                      <Td>{checkNull(r.sum_lung_tap_num)}</Td>
                      <Td>{checkNull(r.sum_bone_marrow_tap_num)}</Td>
                      <Td>{checkNull(r.sum_vacc_rsv_num)}</Td>

                      <Td>{checkNull(r.sum_vacc_flu_num)}</Td>
                      <Td>{checkNull(r.sum_vacc_ipd_num)}</Td>
                      <Td>{checkNull(r.sum_vacc_dengue_num)}</Td>
                      <Td>{checkNull(r.sum_vacc_zoster_num)}</Td>
                      <Td>{checkNull(r.sum_admit_o_case)}</Td>
                      <Td>{checkNull(r.sum_admit_r_case)}</Td>
                      <Td>
                        {checkNull(
                          sumCases(r.sum_admit_o_case, r.sum_admit_r_case)
                        )}
                      </Td>
                      <Td>{checkNull(r.sum_check_up)}</Td>
                      <Td>
                        {getTimeSpent(r)}
                      </Td>
                    </Tr>
                  ))}

                {selectedDoctorID &&
                  records &&
                  records.map((r, index) => (
                    <Tr
                      key={r.day}
                      h={"45px"}
                      style={{ cursor: "pointer" }}
                      onClick={() => handleRowClick(index)}
                    >
                      <Td w={"80px"}>
                        {getThaiDayAbbreviation(r.day)}
                        {r.is_skipted ? (
                          <Text ml={2} color="red.500">
                            (งด)
                          </Text>
                        ) : r.has_additional_period ? (
                          <Text ml={2} color="blue.500">
                            (ชด)
                          </Text>
                        ) : r.start_time && r.end_time ? (
                          <Text></Text>
                        ) : r.start_diag_time && r.end_diag_time ? (
                          <Text></Text>
                        ) : r.is_non_doctor ? (
                          <Text></Text>
                        ) : (
                          <Text ml={2} color="orange.400">
                            (หยุด)
                          </Text>
                        )}
                      </Td>
                      <Td>{checkNull(r.old_o_case)}</Td>
                      <Td>{checkNull(r.new_o_case)}</Td>
                      <Td>{checkNull(sumCases(r.old_o_case, r.new_o_case))}</Td>
                      <Td>{checkNull(r.old_r_case)}</Td>
                      <Td>{checkNull(r.new_r_case)}</Td>
                      <Td>{checkNull(sumCases(r.old_r_case, r.new_r_case))}</Td>
                      <Td>
                        {checkNull(
                          sumCases(
                            sumCases(r.old_o_case, r.new_o_case),
                            sumCases(r.old_r_case, r.new_r_case)
                          )
                        )}
                      </Td>
                      <Td>{checkNull(r.lab_num)}</Td>
                      <Td>{checkNull(r.xray_num)}</Td>
                      <Td>{checkNull(r.ekg_num)}</Td>
                      <Td>{checkNull(r.abi_num)}</Td>
                      <Td>{checkNull(r.obesity_num)}</Td>
                      <Td>{checkNull(r.treatment_num)}</Td>
                      <Td>{checkNull(r.refer_num)}</Td>

                      <Td>{checkNull(r.ct_num)}</Td>
                      <Td>{checkNull(r.pft_num)}</Td>
                      <Td>{checkNull(r.blood_transfusion_num)}</Td>
                      <Td>{checkNull(r.or_num)}</Td>
                      <Td>{checkNull(r.chemo_num)}</Td>
                      <Td>{checkNull(r.blood_letting_num)}</Td>
                      <Td>{checkNull(r.lung_tap_num)}</Td>
                      <Td>{checkNull(r.bone_marrow_tap_num)}</Td>
                      <Td>{checkNull(r.vacc_rsv_num)}</Td>

                      <Td>{checkNull(r.vacc_flu_num)}</Td>
                      <Td>{checkNull(r.vacc_ipd_num)}</Td>
                      <Td>{checkNull(r.vacc_dengue_num)}</Td>
                      <Td>{checkNull(r.vacc_zoster_num)}</Td>
                      <Td>{checkNull(r.admit_o_case)}</Td>
                      <Td>{checkNull(r.admit_r_case)}</Td>
                      <Td>
                        {checkNull(sumCases(r.admit_o_case, r.admit_r_case))}
                      </Td>
                      <Td>{checkNull(r.check_up)}</Td>
                      <Td>
                        <Text fontSize={12}>{getTimeSpent(r)}</Text>
                      </Td>
                      <Td><Text fontSize={12}>{formatTime(r)}</Text></Td>
                      <Td><Text fontSize={12}>{r.has_additional_period ? formatAdditionalTime(r) : ""}</Text></Td>
                    </Tr>
                  ))}

                <Tr bgColor="blue.50" h={"45px"}>
                  <Td>รวม</Td>
                  <Td>{calculateTotalSum("old_o_case")}</Td>
                  <Td>{calculateTotalSum("new_o_case")}</Td>
                  <Td>
                    {calculateTotalSum("old_o_case") +
                      calculateTotalSum("new_o_case")}
                  </Td>
                  <Td>{calculateTotalSum("old_r_case")}</Td>
                  <Td>{calculateTotalSum("new_r_case")}</Td>
                  <Td>
                    {calculateTotalSum("old_r_case") +
                      calculateTotalSum("new_r_case")}
                  </Td>
                  <Td>
                    {calculateTotalSum("old_o_case") +
                      calculateTotalSum("new_o_case") +
                      calculateTotalSum("old_r_case") +
                      calculateTotalSum("new_r_case")}
                  </Td>
                  <Td>{calculateTotalSum("lab_num")}</Td>
                  <Td>{calculateTotalSum("xray_num")}</Td>
                  <Td>{calculateTotalSum("ekg_num")}</Td>
                  <Td>{calculateTotalSum("abi_num")}</Td>
                  <Td>{calculateTotalSum("obesity_num")}</Td>
                  <Td>{calculateTotalSum("treatment_num")}</Td>
                  <Td>{calculateTotalSum("refer_num")}</Td>

                  <Td>{calculateTotalSum("ct_num")}</Td>
                  <Td>{calculateTotalSum("pft_num")}</Td>
                  <Td>{calculateTotalSum("blood_transfusion_num")}</Td>
                  <Td>{calculateTotalSum("or_num")}</Td>
                  <Td>{calculateTotalSum("chemo_num")}</Td>
                  <Td>{calculateTotalSum("blood_letting_num")}</Td>
                  <Td>{calculateTotalSum("lung_tap_num")}</Td>
                  <Td>{calculateTotalSum("bone_marrow_tap_num")}</Td>
                  <Td>{calculateTotalSum("vacc_rsv_num")}</Td>

                  <Td>{calculateTotalSum("vacc_flu_num")}</Td>
                  <Td>{calculateTotalSum("vacc_ipd_num")}</Td>
                  <Td>{calculateTotalSum("vacc_dengue_num")}</Td>
                  <Td>{calculateTotalSum("vacc_zoster_num")}</Td>
                  <Td>{calculateTotalSum("admit_o_case")}</Td>
                  <Td>{calculateTotalSum("admit_r_case")}</Td>
                  <Td>
                    {calculateTotalSum("admit_o_case") +
                      calculateTotalSum("admit_r_case")}
                  </Td>
                  <Td>{calculateTotalSum("check_up")}</Td>
                  <Td>
                    {
                      convertMinutesToHours(calculateTotalSum("minute_spent") + calculateTotalSum("additional_minute_spent"))
                        .hours + " h, " +
                      convertMinutesToHours(calculateTotalSum("minute_spent") + calculateTotalSum("additional_minute_spent"))
                        .minutes + " m "
                    }
                  </Td>
                  <Td display={!selectedDoctorID ? "none" : "table-cell"}></Td>
                  <Td display={!selectedDoctorID ? "none" : "table-cell"}></Td>
                </Tr>
              </Tbody>
            </Table>
          )}

          {!isLoading && histType == "monthly" && records.length == 0 && (
            <Text mt={5}>
              ไม่มีข้อมูลในเดือน{monthStrs[selectedMonth - 1]} {selectedYear}
            </Text>
          )}
          {!isLoading && histType == "yearly" && records.length == 0 && (
            <Text mt={5}>ไม่มีข้อมูลในปี {selectedYear}</Text>
          )}
          {isLoading && (
            <Flex mt={5}>
              <Spinner mr={2} />
              <Text>Loading data...</Text>
            </Flex>
          )}
        </Box>
      </Box>

      <Box
        mb={6}
        mt={2}
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        {user && !isLoading && !isDownloading && (
          <Flex gap={2}>
            <Select
              size={"sm"}
              mr={1}
              w={"120px"}
              onChange={(e) => { setTimeIncluded(e.target.value) }}
              value={timeIncluded}
            >
              <option key={"not_include_time"} value={"time_not_included"}>
                ไม่แสดงเวลา
              </option>
              <option key={"include_time"} value={"time_included"}>
                แสดงเวลา
              </option>
            </Select>

            <Button
              size={"sm"}
              colorScheme="green"
              variant={"outline"}
              onClick={exportToPDF}
            >
              Export PDF
            </Button>

            <Button
              size="sm"
              colorScheme="blue"
              variant="outline"
              onClick={sharePdf}
              isDisabled={!navigator.share}
            >
              Share PDF
            </Button>

          </Flex>
        )}
        {isDownloading && (
          <Flex>
            <Spinner />
            <Text ml={2}>downloading...</Text>
          </Flex>
        )}
      </Box>


      {!isLoading && histType === "yearly" && yearlySummary.length > 0 && (
        <Box>
          <Heading ml={1} mt={6} size="sm" mb={2}>
              สรุปยอดแต่ละรายการในแต่ละเดือนของปี {selectedYear}
              {selectedDoctorID && <> ({getDoctorNameFromID()})</>}
            </Heading>

          <Box overflowX="auto">
            <Table size="xs" className="custom-table">
              <Thead>
                <Tr>
                  <Th px={2} minW="80px">เดือน</Th>
                  <Th px={2}>O เก่า</Th>
                  <Th px={2}>O ใหม่</Th>
                  <Th px={2}>O รวม</Th>
                  <Th px={2}>R เก่า</Th>
                  <Th px={2}>R ใหม่</Th>
                  <Th px={2}>R รวม</Th>
                  <Th px={2}>รวม O+R</Th>
                  <Th px={2}>LAB</Th>
                  <Th px={2}>X-RAY</Th>
                  <Th px={2}>EKG</Th>
                  <Th px={2}>ABI</Th>
                  <Th px={2}>OBESITY</Th>
                  <Th px={2}>TREAT.</Th>
                  <Th px={2}>REFER</Th>
                  <Th px={2}>CT</Th>
                  <Th px={2}>PFT</Th>
                  <Th px={2}>ให้เลือด</Th>
                  <Th px={2}>OR</Th>
                  <Th px={2}>CHEMO</Th>
                  <Th px={2}>BLOOD LETTING</Th>
                  <Th px={2}>เจาะปอด</Th>
                  <Th px={2}>เจาะไขกระดูก</Th>
                  <Th px={2}>V. RSV</Th>
                  <Th px={2}>V. FLU</Th>
                  <Th px={2}>V. IPD</Th>
                  <Th px={2}>V. DENGUE</Th>
                  <Th px={2}>V. ZOSTER</Th>
                  <Th px={2}>O ADM.</Th>
                  <Th px={2}>R ADM.</Th>
                  <Th px={2}>ADM. รวม</Th>
                  <Th px={2}>CHECK UP</Th>
                </Tr>
              </Thead>
              <Tbody>
                {yearlySummary.map((row) => (
                  <Tr key={row.month}>
                    <Td px={2}>{monthStrs[row.month - 1]}</Td>
                    <Td px={2}>{checkNull(row.old_o_case)}</Td>
                    <Td px={2}>{checkNull(row.new_o_case)}</Td>
                    <Td px={2}>{checkNull(row.o_total)}</Td>
                    <Td px={2}>{checkNull(row.old_r_case)}</Td>
                    <Td px={2}>{checkNull(row.new_r_case)}</Td>
                    <Td px={2}>{checkNull(row.r_total)}</Td>
                    <Td px={2}>{checkNull(row.or_total)}</Td>
                    <Td px={2}>{checkNull(row.lab_num)}</Td>
                    <Td px={2}>{checkNull(row.xray_num)}</Td>
                    <Td px={2}>{checkNull(row.ekg_num)}</Td>
                    <Td px={2}>{checkNull(row.abi_num)}</Td>
                    <Td px={2}>{checkNull(row.obesity_num)}</Td>
                    <Td px={2}>{checkNull(row.treatment_num)}</Td>
                    <Td px={2}>{checkNull(row.refer_num)}</Td>
                    <Td px={2}>{checkNull(row.ct_num)}</Td>
                    <Td px={2}>{checkNull(row.pft_num)}</Td>
                    <Td px={2}>{checkNull(row.blood_transfusion_num)}</Td>
                    <Td px={2}>{checkNull(row.or_num)}</Td>
                    <Td px={2}>{checkNull(row.chemo_num)}</Td>
                    <Td px={2}>{checkNull(row.blood_letting_num)}</Td>
                    <Td px={2}>{checkNull(row.lung_tap_num)}</Td>
                    <Td px={2}>{checkNull(row.bone_marrow_tap_num)}</Td>
                    <Td px={2}>{checkNull(row.vacc_rsv_num)}</Td>
                    <Td px={2}>{checkNull(row.vacc_flu_num)}</Td>
                    <Td px={2}>{checkNull(row.vacc_ipd_num)}</Td>
                    <Td px={2}>{checkNull(row.vacc_dengue_num)}</Td>
                    <Td px={2}>{checkNull(row.vacc_zoster_num)}</Td>
                    <Td px={2}>{checkNull(row.admit_o_case)}</Td>
                    <Td px={2}>{checkNull(row.admit_r_case)}</Td>
                    <Td px={2}>{checkNull(row.admit_total)}</Td>
                    <Td px={2}>{checkNull(row.check_up)}</Td>
                  </Tr>
                ))}

                {/* แถวรวมทั้งปี (มีแค่ Tr เดียว ไม่อยู่ใน map) */}
                <Tr bgColor="blue.50" fontWeight="bold">
                  <Td px={2}>รวม</Td>
                  <Td px={2}>{checkNull(getYearlyTotal("old_o_case"))}</Td>
                  <Td px={2}>{checkNull(getYearlyTotal("new_o_case"))}</Td>
                  <Td px={2}>{checkNull(getYearlyTotal("o_total"))}</Td>
                  <Td px={2}>{checkNull(getYearlyTotal("old_r_case"))}</Td>
                  <Td px={2}>{checkNull(getYearlyTotal("new_r_case"))}</Td>
                  <Td px={2}>{checkNull(getYearlyTotal("r_total"))}</Td>
                  <Td px={2}>{checkNull(getYearlyTotal("or_total"))}</Td>
                  <Td px={2}>{checkNull(getYearlyTotal("lab_num"))}</Td>
                  <Td px={2}>{checkNull(getYearlyTotal("xray_num"))}</Td>
                  <Td px={2}>{checkNull(getYearlyTotal("ekg_num"))}</Td>
                  <Td px={2}>{checkNull(getYearlyTotal("abi_num"))}</Td>
                  <Td px={2}>{checkNull(getYearlyTotal("obesity_num"))}</Td>
                  <Td px={2}>{checkNull(getYearlyTotal("treatment_num"))}</Td>
                  <Td px={2}>{checkNull(getYearlyTotal("refer_num"))}</Td>
                  <Td px={2}>{checkNull(getYearlyTotal("ct_num"))}</Td>
                  <Td px={2}>{checkNull(getYearlyTotal("pft_num"))}</Td>
                  <Td px={2}>{checkNull(getYearlyTotal("blood_transfusion_num"))}</Td>
                  <Td px={2}>{checkNull(getYearlyTotal("or_num"))}</Td>
                  <Td px={2}>{checkNull(getYearlyTotal("chemo_num"))}</Td>
                  <Td px={2}>{checkNull(getYearlyTotal("blood_letting_num"))}</Td>
                  <Td px={2}>{checkNull(getYearlyTotal("lung_tap_num"))}</Td>
                  <Td px={2}>{checkNull(getYearlyTotal("bone_marrow_tap_num"))}</Td>
                  <Td px={2}>{checkNull(getYearlyTotal("vacc_rsv_num"))}</Td>
                  <Td px={2}>{checkNull(getYearlyTotal("vacc_flu_num"))}</Td>
                  <Td px={2}>{checkNull(getYearlyTotal("vacc_ipd_num"))}</Td>
                  <Td px={2}>{checkNull(getYearlyTotal("vacc_dengue_num"))}</Td>
                  <Td px={2}>{checkNull(getYearlyTotal("vacc_zoster_num"))}</Td>
                  <Td px={2}>{checkNull(getYearlyTotal("admit_o_case"))}</Td>
                  <Td px={2}>{checkNull(getYearlyTotal("admit_r_case"))}</Td>
                  <Td px={2}>{checkNull(getYearlyTotal("admit_total"))}</Td>
                  <Td px={2}>{checkNull(getYearlyTotal("check_up"))}</Td>
                </Tr>
              </Tbody>
            </Table>
          </Box>
          <Flex w={"100%"} justify={"center"} mt={2} mb={2} gap={2}>
            <Button
              size="sm"
              colorScheme="green"
              variant="outline"
              onClick={exportYearlySummaryPdf}
              isDisabled={isDownloading}
            >
              Export PDF
            </Button>
            <Button
              size="sm"
              colorScheme="blue"
              variant="outline"
              onClick={shareYearlySummaryPdf}
              isDisabled={isDownloading || !navigator.share}
            >
              Share PDF
            </Button>
          </Flex>

        </Box>
      )}

      {/* ✅ ตารางใหม่: O+R รายเดือน แยกแพทย์ */}
      {!isLoading && histType === "yearly" && doctorMonthlyRows.length > 0 && (
        <Box>
          <Heading ml={1} size="sm" mt={6}>
              สถิติยอดคนไข้ (O+R) รายเดือน แยกตามแพทย์ (ปี {selectedYear})
            </Heading>
          <Box overflowX="auto">
            {isDoctorMonthlyLoading && (
              <Flex align="center" mb={2}>
                <Spinner size="sm" mr={2} />
                <Text>กำลังโหลดสรุปรายเดือน...</Text>
              </Flex>
            )}

            {!isDoctorMonthlyLoading && (
              <Table size="xs" className="custom-table" mt={2}>
                <Thead>
                  <Tr>
                    <Th px={2} minW="140px">
                      แพทย์
                    </Th>
                    <Th px={2} minW="120px">
                      จำนวน
                    </Th>
                    <Th px={2} minW="80px">
                      % จากยอดรวม
                    </Th>
                    {monthShortStrs.map((m) => (
                      <Th key={m} px={2}>
                        {m}
                      </Th>
                    ))}
                  </Tr>
                </Thead>
                <Tbody>
                  {doctorMonthlyRows.map((row) => (
                    <Tr key={row.name}>
                      <Td px={2}>{row.name}</Td>
                      <Td px={2}>
                        {row.total
                          ? `${row.total.toLocaleString()}`
                          : ""}
                      </Td>
                      <Td px={2}>{`${row.percent.toFixed(
                            1
                          )}%`}</Td>
                      {row.monthly.map((val, idx) => (
                        <Td key={idx} px={2}>
                          {checkNull(val)}
                        </Td>
                      ))}
                    </Tr>
                  ))}

                  {/* แถวรวมแต่ละเดือน */}
                  <Tr bgColor="blue.50" fontWeight="bold">
                    <Td px={2}>รวม</Td>
                    <Td px={2}>{checkNull(doctorMonthlyGrandTotal)}</Td>
                    <Td px={2}></Td>
                    {monthShortStrs.map((_, idx) => (
                      <Td key={idx} px={2}>
                        {checkNull(
                          doctorMonthlyRows.reduce(
                            (sum, row) => sum + (row.monthly[idx] || 0),
                            0
                          )
                        )}
                      </Td>
                    ))}
                  </Tr>
                </Tbody>
              </Table>
            )}

          </Box>
          <Flex justify={"center"} mt={2} mb={2} gap={2}>
            <Button
              size="sm"
              colorScheme="green"
              variant="outline"
              onClick={exportDoctorMonthlyPdf}
              isDisabled={isDownloading}
            >
              Export PDF
            </Button>
            <Button
              size="sm"
              colorScheme="blue"
              variant="outline"
              onClick={shareDoctorMonthlyPdf}
              isDisabled={isDownloading || !navigator.share}
            >
              Share PDF
            </Button>
          </Flex>
        </Box>
      )}

    </Box>
  );
};

export default PatientHist;
